import Draggable from "react-draggable";
import { Link } from "react-router-dom";

function DragsPop(props) {
  return (
    <Draggable handle="strong">
      <div className="layer-box shadow-lg">
        <strong className="cursor layer-pop-title-bar">
          <ul className="d-flex justify-content-between p-0 m-0">
            <li>알림</li>
            <li>
              <i
                className="icofont-close-squared-alt"
                onClick={(e) => props.setIsPopup((prev) => !prev)}
              ></i>
            </li>
          </ul>
        </strong>
        <div className="layer-body text-center">
          <h3>자동차 정기검사업체 안내</h3>
          <p className="pt-2">
            강원특별자치도지사로부터 지정받은 가장 가까운 자동차 검사업체를
            검색할 수 있습니다.
          </p>
          <Link to="/UnionMem?testkind=2">
            <button className="col-12 btn btn-primary mt-3">
              자동차 정기·종합 검사업체 바로가기
            </button>
          </Link>
          <button
            className="col-12 btn btn-primary mt-3"
            onClick={(e) =>
              window.open(
                "https://www.cyberts.kr/is/pvi/pvi/readIsPviPrsecValidityInqireView.do"
              )
            }
          >
            자동차 검사유효기간 조회 바로가기
          </button>
        </div>
      </div>
    </Draggable>
  );
}

export default DragsPop;
